

import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/dectwin-billing-logo.jpeg";
import axios from "axios";
import { Eye, EyeOff } from "lucide-react";


import {
  showSuccess,
  showError,
} from "../../General/Toast";

const Login = ({ setIsLogin }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showLoginPassword, setShowLoginPassword] = useState(false);
const [showSignupPassword, setShowSignupPassword] = useState(false);
const [showResetPassword, setShowResetPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [isSignup, setIsSignup] = useState(false);
const handleMobileChange = (e, type) => {
  const value = e.target.value.replace(/\D/g, "").slice(0, 10);

  if (type === "login") {
    setLoginData({
      ...loginData,
      mobile: value,
    });
  }

  if (type === "signup") {
    setSignupData({
      ...signupData,
      mobile: value,
    });
  }
};
  // Header Login button se aane par hamesha Sign In open hoga
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.get("signin") === "1") {
      setIsSignup(false);
      setSignupStep(1);
    }
  }, [location.search]);
  const [userType, setUserType] = useState("admin");
  const [signupStep, setSignupStep] = useState(1);

  const [state, setState] = useState("");
  const [userId, setUserId] = useState();

  const [showForgotPassword, setShowForgotPassword] =
    useState(false);

  const [otpVerified, setOtpVerified] = useState(false);
  const [generatedOtp, setGeneratedOtp] = useState("");

  const [resetData, setResetData] = useState({
    mobile: "",
    otp: "",
    pass: "",
    confirmPass: "",
  });

  const [signupData, setSignupData] = useState({
    business_name: "",
    mobile: "",
    pass: "",
    type: "",
    category: "",
    gst: "",
    address: "",
    state: "",
    pin: "",
    source: "Web",
  });
  

  const [loginData, setLoginData] = useState({
    mobile: "",
    pass: "",
  });


 
  const sendResetOtp = async () => {
    if (!loginData.mobile) {
      showError("Please enter mobile number");
      return;
    }

    try {
      const response = await axios.post(
        "https://api.dectwinbilling.com/send-otp",
        {
          mobile: loginData.mobile,
        }
      );

      setGeneratedOtp(response.data.otp);

      setResetData({
        mobile: loginData.mobile,
        otp: "",
        pass: "",
        confirmPass: "",
      });

      setOtpVerified(false);
      setShowForgotPassword(true);

      showSuccess(response.data.message);

    } catch (error) {
      showError(
        error.response?.data?.message ||
          "Server Error"
      );
    }
  };


  /* =====================================================
     VERIFY OTP
  ===================================================== */

  const verifyOtp = () => {
    if (resetData.otp !== generatedOtp) {
      showError("Invalid OTP");
      return;
    }

    showSuccess("OTP Verified");
    setOtpVerified(true);
  };


  /* =====================================================
     RESET PASSWORD
  ===================================================== */

  const handleResetPassword = async () => {

    if (resetData.otp === "") {
      showError("Please enter OTP");
      return;
    }

    if (resetData.pass === "") {
      showError("Please enter new password");
      return;
    }

    if (resetData.confirmPass === "") {
      showError("Please confirm password");
      return;
    }

    if (resetData.otp !== generatedOtp) {
      showError("Invalid OTP");
      return;
    }

    if (
      resetData.pass !==
      resetData.confirmPass
    ) {
      showError("Passwords do not match");
      return;
    }

    try {

      const res = await axios.put(
        "https://api.dectwinbilling.com/reset-password",
        {
          mobile: resetData.mobile,
          pass: resetData.pass,
        }
      );

      showSuccess(res.data.message);

      setGeneratedOtp("");

      setResetData({
        mobile: "",
        otp: "",
        pass: "",
        confirmPass: "",
      });

      setShowForgotPassword(false);
      setOtpVerified(false);

    } catch (error) {

      showError(
        error.response?.data?.message ||
          "Password Reset Failed"
      );
    }
  };


  /* =====================================================
     CREATE ACCOUNT
  ===================================================== */

  // const handleSignup = async () => {

  //   try {

  //     const res = await axios.post(
  //       "https://api.dectwinbilling.com/create-account",
  //       signupData
  //     );

  //     setUserId(res.data.insertId);

  //     localStorage.setItem(
  //       "client_id",
  //       res.data.insertId
  //     );

  //     showSuccess(
  //       "Account Created Successfully"
  //     );

  //     setSignupStep(2);

  //   } catch (error) {

  //     showError(
  //       error.response?.data?.message ||
  //         "Server Error"
  //     );
  //   }
  // };
// const handleSignup = async () => {
//   try {
//     const res = await axios.post(
//       "https://api.dectwinbilling.com/create-account",
//       signupData
//     );

//     setUserId(res.data.insertId);

//     localStorage.setItem(
//       "client_id",
//       res.data.insertId
//     );

//     showSuccess("Account Created Successfully");

//     setSignupStep(2);

//   } catch (error) {
//     showError(
//       error.response?.data?.message ||
//       "Server Error"
//     );
//   }
// };
// const handleSignup = async () => {

//   // Mobile number validation
//   if (!/^[6-9]\d{9}$/.test(signupData.mobile)) {
//     showError("Please enter a valid 10 digit mobile number");
//     return;
//   }

//   try {
//     const res = await axios.post(
//       "https://api.dectwinbilling.com/create-account",
//       signupData
//     );

//     setUserId(res.data.insertId);

//     localStorage.setItem(
//       "client_id",
//       res.data.insertId
//     );

//     showSuccess("Account Created Successfully");

//     setSignupStep(2);

//   } catch (error) {
//     showError(
//       error.response?.data?.message ||
//       "Server Error"
//     );
//   }
// };
const handleSignup = async () => {
  // Exactly 10 digit mobile number
  if (!/^\d{10}$/.test(signupData.mobile)) {
    showError("Please enter a valid 10 digit mobile number");
    return;
  }

  try {
    const res = await axios.post(
      "https://api.dectwinbilling.com/create-account",
      signupData
    );

    setUserId(res.data.insertId);

    localStorage.setItem(
      "client_id",
      res.data.insertId
    );

    showSuccess("Account Created Successfully");

    setSignupStep(2);

  } catch (error) {
    showError(
      error.response?.data?.message ||
      "Server Error"
    );
  }
};
  /* =====================================================
     SAVE BUSINESS DETAILS
  ===================================================== */

  // const handleSubmit = async () => {

  //   try {

  //     const res = await axios.put(
  //       `https://api.dectwinbilling.com/update-account/${userId}`,
  //       {
  //         gst: signupData.gst,
  //         category: signupData.category,
  //         type: signupData.type,
  //         address: signupData.address,
  //         state: signupData.state,
  //         pin: signupData.pin,
  //       }
  //     );

  //     console.log(res.data);

  //     showSuccess(
  //       "Business Details Saved Successfully"
  //     );

  //     setSignupStep(3);

  //   } catch (error) {

  //     showError(
  //       error.response?.data?.message ||
  //         "Server Error"
  //     );
  //   }
  // };
// const handleSubmit = async () => {
//   try {
//     await axios.put(
//       `https://api.dectwinbilling.com/update-account/${userId}`,
//       {
//         gst: signupData.gst,
//         category: signupData.category,
//         type: signupData.type,
//         address: signupData.address,
//         state: signupData.state,
//         pin: signupData.pin,
//       }
//     );

//     const createdUser = {
//       id: userId,
//       business_name: signupData.business_name,
//       mobile: signupData.mobile,
//       role: "Owner",
//       type: signupData.type,
//       category: signupData.category,
//       gst: signupData.gst,
//       address: signupData.address,
//       state: signupData.state,
//       pin: signupData.pin,
//       source: "Web",
//     };

//     localStorage.setItem(
//       "user_data",
//       JSON.stringify(createdUser)
//     );

//     localStorage.setItem(
//       "client_id",
//       String(userId)
//     );

//     localStorage.setItem(
//       "role",
//       "admin"
//     );

//     // AUTO LOGIN ONLY FOR SIGNUP
//     setIsLogin(true);

//     showSuccess("Account Created Successfully");

//     // Directly go Home
//     navigate("/home", { replace: true });

//   } catch (error) {
//     showError(
//       error.response?.data?.message ||
//       "Server Error"
//     );
//   }
// };
const handleSubmit = async () => {
  try {
    await axios.put(
      `https://api.dectwinbilling.com/update-account/${userId}`,
      {
        gst: signupData.gst,
        category: signupData.category,
        type: signupData.type,
        address: signupData.address,
        state: signupData.state,
        pin: signupData.pin,
      }
    );

    showSuccess("Account Created Successfully");

    // ==============================
    // GO TO SIGN IN AFTER SIGNUP
    // ==============================

    // Flip back to Sign In
    setIsSignup(false);

    // Reset signup steps
    setSignupStep(1);

    // Automatically fill mobile number
    // Password will remain empty
    setLoginData({
      mobile: signupData.mobile,
      pass: "",
    });

  } catch (error) {
    console.error("Signup Error:", error);

    showError(
      error.response?.data?.message ||
      "Server Error"
    );
  }
};
  /* =====================================================
     LOGIN
  ===================================================== */

  // const handleLogin = async () => {

  //   try {

  //     let role = "";

  //     if (userType === "admin") {
  //       role = "Owner";
  //     }

  //     if (userType === "staff") {
  //       role = "Employee";
  //     }

  //     const res = await axios.put(
  //       "https://api.dectwinbilling.com/user-login",
  //       {
  //         mobile: loginData.mobile,
  //         pass: loginData.pass,
  //         role,
  //       }
  //     );

  //     console.log("Response =", res.data);

  //     localStorage.setItem(
  //       "user_data",
  //       JSON.stringify(res.data)
  //     );

  //     localStorage.setItem(
  //       "client_id",
  //       res.data.id
  //     );

  //     localStorage.setItem(
  //       "role",
  //       userType
  //     );

  //     showSuccess("Login Successful");

  //     setTimeout(() => {
  //       setIsLogin(true);
  //       navigate("/home");
  //     }, 1500);

  //   } catch (error) {

  //     showError(
  //       error.response?.data?.message ||
  //         "Login Failed"
  //     );
  //   }
  // };
const handleLogin = async () => {

  // Mobile validation
  const mobile = String(loginData.mobile || "")
    .replace(/\D/g, "")
    .slice(0, 10);

  if (mobile.length !== 10) {
    showError("Please enter a valid 10 digit mobile number");
    return;
  }

  try {
    let role = "";

    if (userType === "admin") {
      role = "Owner";
    }

    if (userType === "staff") {
      role = "Employee";
    }

    const res = await axios.put(
      "https://api.dectwinbilling.com/user-login",
      {
        mobile: mobile,
        pass: loginData.pass,
        role,
      }
    );

    console.log("Response =", res.data);

    localStorage.setItem(
      "user_data",
      JSON.stringify(res.data)
    );

    localStorage.setItem(
      "client_id",
      res.data.id
    );

    localStorage.setItem(
      "role",
      userType
    );
showSuccess(
  userType === "staff"
    ? "Staff Login Successful"
    : " Login Successful"
);
    // showSuccess("Login Successful");

    setTimeout(() => {
      setIsLogin(true);
      navigate("/home");
    }, 1500);

  } catch (error) {
    console.error("Login Error:", error);

    showError(
      error.response?.data?.message ||
      "Login Failed"
    );
  }
};
  /* =====================================================
     COMMON INPUT STYLE
  ===================================================== */

  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #d1d5db",
    borderRadius: "7px",
    outline: "none",
    fontSize: "14px",
    boxSizing: "border-box",
  };


  /* =====================================================
     MAIN BUTTON
  ===================================================== */

  const mainButton = {
    padding: "10px 28px",
    border: "none",
    borderRadius: "25px",
    background: "#ff4b2b",
    color: "#fff",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
  };


  /* =====================================================
     OUTLINE BUTTON
  ===================================================== */

  const outlineButton = {
    padding: "10px 28px",
    borderRadius: "25px",
    border: "1px solid #fff",
    background: "transparent",
    color: "#fff",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
  };


  return (

    <div
      className="min-vh-100 d-flex justify-content-center align-items-center"
      style={{
        background: "#f6f7f9",
        padding: "80px 40px",
      }}
    >

      {/* =================================================
          MAIN CARD
      ================================================= */}

      <div
        className="container-fluid bg-white shadow overflow-hidden"
        style={{
          maxWidth: "820px",
          borderRadius: "16px",
        }}
      >

        <div className="row g-0">


          {/* =================================================
              WHITE FORM PANEL
          ================================================= */}

          <div
            className={`col-12 col-md-6 d-flex justify-content-center align-items-center p-3 p-md-4 ${
              isSignup
                ? "order-md-2"
                : "order-md-1"
            }`}
          >

            <div
              className="w-100"
              style={{
                maxWidth: "350px",
              }}
            >

              {/* =================================================
                  LOGIN
              ================================================= */}

              {!isSignup ? (

                <>

                  {showForgotPassword ? (

                    /* ================= RESET PASSWORD ================= */

                    <div className="text-center">

                      <h1
                        className="fw-bold mb-3"
                        style={{
                          fontSize: "28px",
                        }}
                      >
                        Reset Password
                      </h1>


                      {!otpVerified ? (

                        <div className="text-start">

                          <div className="mb-3">

                            <label className="form-label fw-semibold small">
                              Enter OTP
                            </label>

                            <input
                              type="text"
                              placeholder="Enter OTP"
                              value={
                                resetData.otp
                              }
                              onChange={(e) =>
                                setResetData({
                                  ...resetData,
                                  otp: e.target.value,
                                })
                              }
                              style={inputStyle}
                            />

                          </div>

                        </div>

                      ) : (

                        <div className="text-start">

                          <div className="mb-3">

                            <label className="form-label fw-semibold small">
                              New Password
                            </label>

                            <input
                              type="password"
                              placeholder="Enter New Password"
                              value={
                                resetData.pass
                              }
                              onChange={(e) =>
                                setResetData({
                                  ...resetData,
                                  pass: e.target.value,
                                })
                              }
                              style={inputStyle}
                            />

                          </div>


                          <div className="mb-3">

                            <label className="form-label fw-semibold small">
                              Confirm Password
                            </label>

                            <input
                              type="password"
                              placeholder="Confirm Password"
                              value={
                                resetData.confirmPass
                              }
                              onChange={(e) =>
                                setResetData({
                                  ...resetData,
                                  confirmPass:
                                    e.target.value,
                                })
                              }
                              style={inputStyle}
                            />

                          </div>

                        </div>

                      )}


                      <div className="d-flex justify-content-center gap-2 flex-wrap mt-3">

                        <button
                          type="button"
                          style={{
                            ...mainButton,
                            background:
                              "#6b7280",
                          }}
                          onClick={() => {
                            setShowForgotPassword(
                              false
                            );
                            setOtpVerified(false);
                          }}
                        >
                          Cancel
                        </button>


                        <button
                          type="button"
                          style={mainButton}
                          onClick={
                            !otpVerified
                              ? verifyOtp
                              : handleResetPassword
                          }
                        >
                          {!otpVerified
                            ? "Verify OTP"
                            : "Reset Password"}
                        </button>

                      </div>

                    </div>

                  ) : (

                    /* ================= LOGIN FORM ================= */

                    <div className="text-center">

                      <h1
                        className="fw-bold mb-3"
                        style={{
                          fontSize: "18px",
                          color: "#111827",
                        }}
                      >
                        Sign In
                      </h1>


                      {/* ADMIN / STAFF */}

                      <div
                        className="d-flex bg-light rounded-pill p-1 mb-3"
                      >

                        <button
                          type="button"
                          onClick={() =>
                            setUserType("admin")
                          }
                          className="btn flex-fill rounded-pill"
                          style={{
                            background:
                              userType === "admin"
                                ? "#ff4b2b"
                                : "transparent",
                            color:
                              userType === "admin"
                                ? "#fff"
                                : "#555",
                            fontWeight: "600",
                            padding: "8px",
                          }}
                        >
                          Admin
                        </button>


                        <button
                          type="button"
                          onClick={() =>
                            setUserType("staff")
                          }
                          className="btn flex-fill rounded-pill"
                          style={{
                            background:
                              userType === "staff"
                                ? "#ff4b2b"
                                : "transparent",
                            color:
                              userType === "staff"
                                ? "#fff"
                                : "#555",
                            fontWeight: "600",
                            padding: "8px",
                          }}
                        >
                          Staff
                        </button>

                      </div>


                      <h2
                        className="fw-bold mb-3"
                        style={{
                          fontSize: "18px",
                          color: "#111827",
                        }}
                      >
                        {userType === "admin"
                          ? "Admin Login"
                          : "Staff Login"}
                      </h2>


                      {/* MOBILE */}

                      {/* <div className="text-start mb-3">

                        <label className="form-label fw-semibold small">
                          Mobile Number
                        </label>

                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Enter your mobile number"
                          value={
                            loginData.mobile
                          }
                          onChange={(e) =>
                            setLoginData({
                              ...loginData,
                              mobile:
                                e.target.value,
                            })
                          }
                        />

                      </div> */}
                      <div style={{ position: "relative" }}>
  <span
    style={{
      position: "absolute",
      left: "12px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#374151",
      fontSize: "14px",
      zIndex: 2,
    }}
  >
    +91
  </span>
<input
  type="tel"
  className="form-control"
  placeholder="Enter 10 digit mobile number"
  value={loginData.mobile}
  maxLength={10}
  inputMode="numeric"
  onChange={(e) =>
    handleMobileChange(e, "login")
  }
  style={{
    paddingLeft: "48px",
  }}
/>
</div>


                      {/* PASSWORD */}

                      {/* <div className="text-start mb-2">

                        <label className="form-label fw-semibold small">
                          Password
                        </label>

                        <input
                          type="password"
                          className="form-control"
                          placeholder="Enter your password"
                          value={
                            loginData.pass
                          }
                          onChange={(e) =>
                            setLoginData({
                              ...loginData,
                              pass:
                                e.target.value,
                            })
                          }
                        />

                      </div> */}

<div className="text-start mb-2">
  <label className="form-label fw-semibold small">
    Password
  </label>

  <div style={{ position: "relative" }}>
    <input
      type={showLoginPassword ? "text" : "password"}
      className="form-control"
      placeholder="Enter your password"
      value={loginData.pass}
      onChange={(e) =>
        setLoginData({
          ...loginData,
          pass: e.target.value,
        })
      }
      style={{
        paddingRight: "45px",
      }}
    />

    <button
      type="button"
      onClick={() =>
        setShowLoginPassword(!showLoginPassword)
      }
      style={{
        position: "absolute",
        right: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        border: "none",
        background: "transparent",
        cursor: "pointer",
        padding: "4px",
        display: "flex",
        alignItems: "center",
        color: "#6b7280",
      }}
    >
      {showLoginPassword ? (
        <EyeOff size={19} />
      ) : (
        <Eye size={19} />
      )}
    </button>
  </div>
</div>
                      {/* FORGOT */}

                      <div className="text-end mb-2">

                        <span
                          onClick={
                            sendResetOtp
                          }
                          style={{
                            cursor: "pointer",
                            fontSize: "13px",
                            color: "#374151",
                          }}
                        >
                          Forgot Password?
                        </span>

                      </div>


                      {/* LOGIN BUTTON */}

                      <button
                        type="button"
                        onClick={handleLogin}
                        className="btn text-white rounded-pill px-4"
                        style={{
                          background:
                            "#ff4b2b",
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                      >
                        SIGN IN
                      </button>

                    </div>

                  )}

                </>

              ) : (

                /* =================================================
                   SIGNUP
                ================================================= */

                <div className="text-center">

                  {signupStep === 1 ? (

                    <>
                      <h1
                        className="fw-bold mb-3"
                        style={{
                          fontSize: "27px",
                        }}
                      >
                        Create Account
                      </h1>


                      <div className="text-start mb-3">

                        <label className="form-label fw-semibold small">
                          Business Name
                        </label>

                        <input
                          type="text"
                          placeholder="Enter Business Name"
                          style={inputStyle}
                          value={
                            signupData.business_name
                          }
                          onChange={(e) =>
                            setSignupData({
                              ...signupData,
                              business_name:
                                e.target.value,
                            })
                          }
                        />

                      </div>


                    <div style={{ position: "relative" }}>
  <span
    style={{
      position: "absolute",
      left: "12px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#374151",
      fontSize: "14px",
      zIndex: 2,
    }}
  >
    +91
  </span>

  <input
    type="tel"
    placeholder="Enter 10 digit mobile number"
    value={signupData.mobile}
    maxLength={10}
    inputMode="numeric"
    onChange={(e) =>
      handleMobileChange(e, "signup")
    }
    style={{
      ...inputStyle,
      paddingLeft: "48px",
    }}
  />
</div>

                      {/* <div className="text-start mb-3">

                        <label className="form-label fw-semibold small">
                          Password
                        </label>

                        <input
                          type="password"
                          placeholder="Enter Password"
                          style={inputStyle}
                          value={
                            signupData.pass
                          }
                          onChange={(e) =>
                            setSignupData({
                              ...signupData,
                              pass:
                                e.target.value,
                            })
                          }
                        />

                      </div> */}
<div className="text-start mb-3">
  <label className="form-label fw-semibold small">
    Password
  </label>

  <div style={{ position: "relative" }}>
    <input
      type={showSignupPassword ? "text" : "password"}
      placeholder="Enter Password"
      style={{
        ...inputStyle,
        paddingRight: "45px",
      }}
      value={signupData.pass}
      onChange={(e) =>
        setSignupData({
          ...signupData,
          pass: e.target.value,
        })
      }
    />

    <button
      type="button"
      onClick={() =>
        setShowSignupPassword(!showSignupPassword)
      }
      style={{
        position: "absolute",
        right: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        border: "none",
        background: "transparent",
        cursor: "pointer",
        padding: "4px",
        display: "flex",
        alignItems: "center",
        color: "#6b7280",
      }}
    >
      {showSignupPassword ? (
        <EyeOff size={19} />
      ) : (
        <Eye size={19} />
      )}
    </button>
  </div>
</div>

                      <button
                        type="button"
                        style={mainButton}
                        onClick={handleSignup}
                      >
                        SIGNUP
                      </button>

                    </>

                  ) : signupStep === 2 ? (

                    /* ================= BUSINESS DETAILS ================= */

                    <>
                      <h1
                        className="fw-bold mb-3"
                        style={{
                          fontSize: "27px",
                        }}
                      >
                        Business Details
                      </h1>


                      <div className="text-start mb-3">

                        <label className="form-label fw-semibold small">
                          Business Type
                        </label>

                        <select
                          style={inputStyle}
                          value={
                            signupData.type ||
                            ""
                          }
                          onChange={(e) =>
                            setSignupData({
                              ...signupData,
                              type:
                                e.target.value,
                            })
                          }
                        >
                          <option value="">
                            Select Business Type
                          </option>

                          <option value="Retail">
                            Retail
                          </option>

                          <option value="Service">
                            Service
                          </option>

                          <option value="Wholeseller">
                            Wholeseller
                          </option>
                        </select>

                      </div>


                      <div className="text-start mb-3">

                        <label className="form-label fw-semibold small">
                          Business Category
                        </label>

                        <input
                          type="text"
                          placeholder="Enter Business Category"
                          style={inputStyle}
                          value={
                            signupData.category ||
                            ""
                          }
                          onChange={(e) =>
                            setSignupData({
                              ...signupData,
                              category:
                                e.target.value,
                            })
                          }
                        />

                      </div>


                      <div className="text-start mb-3">

                        <label className="form-label fw-semibold small">
                          GST Number
                        </label>

                        <input
                          type="text"
                          placeholder="Enter GST Number"
                          style={inputStyle}
                          value={
                            signupData.gst || ""
                          }
                          onChange={(e) =>
                            setSignupData({
                              ...signupData,
                              gst:
                                e.target.value,
                            })
                          }
                        />

                      </div>


                      <div className="d-flex justify-content-center gap-2 flex-wrap">

                        <button
                          type="button"
                          className="btn btn-secondary rounded-pill px-4"
                          onClick={() =>
                            setSignupStep(1)
                          }
                        >
                          BACK
                        </button>


                        <button
                          type="button"
                          style={mainButton}
                          onClick={() =>
                            setSignupStep(3)
                          }
                        >
                          NEXT
                        </button>

                      </div>

                    </>

                  ) : (

                    /* ================= ADDRESS ================= */

                    <>
                      <h1
                        className="fw-bold mb-3"
                        style={{
                          fontSize: "27px",
                        }}
                      >
                        Address Details
                      </h1>


                      <div className="text-start mb-3">

                        <label className="form-label fw-semibold small">
                          Address
                        </label>

                        <textarea
                          rows={3}
                          placeholder="Enter Address"
                          value={
                            signupData.address
                          }
                          onChange={(e) =>
                            setSignupData({
                              ...signupData,
                              address:
                                e.target.value,
                            })
                          }
                          style={{
                            ...inputStyle,
                            resize: "none",
                          }}
                        />

                      </div>


                      <div className="text-start mb-3">

                        <label className="form-label fw-semibold small">
                          State
                        </label>

                        <select
                          style={inputStyle}
                          value={
                            signupData.state
                          }
                          onChange={(e) =>
                            setSignupData({
                              ...signupData,
                              state:
                                e.target.value,
                            })
                          }
                        >

                          <option value="">
                            Select State
                          </option>

                          <option>
                            Andhra Pradesh
                          </option>

                          <option>
                            Arunachal Pradesh
                          </option>

                          <option>Assam</option>
                          <option>Bihar</option>
                          <option>Chhattisgarh</option>
                          <option>Delhi</option>
                          <option>Goa</option>
                          <option>Gujarat</option>
                          <option>Haryana</option>
                          <option>Himachal Pradesh</option>
                          <option>Jharkhand</option>
                          <option>Karnataka</option>
                          <option>Kerala</option>
                          <option>Madhya Pradesh</option>
                          <option>Maharashtra</option>
                          <option>Manipur</option>
                          <option>Meghalaya</option>
                          <option>Mizoram</option>
                          <option>Nagaland</option>
                          <option>Odisha</option>
                          <option>Punjab</option>
                          <option>Rajasthan</option>
                          <option>Sikkim</option>
                          <option>Tamil Nadu</option>
                          <option>Telangana</option>
                          <option>Tripura</option>
                          <option>Uttar Pradesh</option>
                          <option>Uttarakhand</option>
                          <option>West Bengal</option>

                        </select>

                      </div>


                      <div className="text-start mb-3">

                        <label className="form-label fw-semibold small">
                          Pincode
                        </label>

                        <input
                          type="text"
                          placeholder="Enter Pincode"
                          style={inputStyle}
                          value={
                            signupData.pin || ""
                          }
                          onChange={(e) =>
                            setSignupData({
                              ...signupData,
                              pin:
                                e.target.value,
                            })
                          }
                        />

                      </div>


                      <div className="d-flex justify-content-center gap-2 flex-wrap">

                        <button
                          type="button"
                          className="btn btn-secondary rounded-pill px-4"
                          onClick={() =>
                            setSignupStep(2)
                          }
                        >
                          BACK
                        </button>

{/* 
                        <button
                          type="button"
                          style={mainButton}
                          onClick={handleSubmit}
                        >
                          SUBMIT
                        </button> */}
                        <button
  type="button"
  style={mainButton}
  onClick={handleSubmit}
>
  SUBMIT
</button>

                      </div>

                    </>

                  )}

                </div>

              )}

            </div>

          </div>


          {/* =================================================
              RED PANEL
          ================================================= */}

          <div
            className={`col-12 col-md-6 d-flex justify-content-center align-items-center text-center text-white p-4 ${
              isSignup
                ? "order-md-1"
                : "order-md-2"
            }`}
            style={{
              background:
                "linear-gradient(135deg,#ff4b2b,#ff416c)",
              minHeight: "300px",
            }}
          >

            <div
              className="w-100 d-flex flex-column align-items-center"
              style={{
                maxWidth: "280px",
              }}
            >

              <img
                src={logo}
                alt="Dectwin Billing"
                className="img-fluid mb-3"
                style={{
                  width: "65px",
                  height: "65px",
                  objectFit: "contain",
                }}
              />


              {!isSignup ? (

                <>
<p
  className="fw-bold mb-2 fs-4"
  style={{ fontFamily: '"Montserrat", sans-serif' }}
>
  Hello, Friend!
</p>         <small
                    className="small mb-4"
                    style={{
                      lineHeight: "20px",
                    }}
                  >
                    Enter your personal details
                    and start your journey with us
                  </small>

                  {/* <button
                    type="button"
                    onClick={() =>
                      setIsSignup(true)
                    }
                    style={outlineButton}
                  >
                    SIGN UP
                  </button> */}
                  <button
  type="button"
  onClick={() => setIsSignup(true)}
  style={outlineButton}
>
  SIGN UP
</button>
                </>

              ) : (

                <>
                  {/* <h1
                    className="fw-bold mb-2"
                    style={{
                      fontSize: "30px",
                    }}
                  >
                    Welcome Back!
                  </h1> */}
                  <p
  className="fw-bold mb-2 fs-4"
  style={{ fontFamily: '"Montserrat", sans-serif' }}
>
  Welcome Back!
</p>

                  <p
                    className="small mb-4"
                    style={{
                      lineHeight: "20px",
                    }}
                  >
                    To keep connected with us
                    please login with your
                    personal info
                  </p>

                 
                  <button
  type="button"
  onClick={() => setIsSignup(false)}
  style={outlineButton}
>
  SIGN IN
</button>
                </>

              )}

            </div>

          </div>

        </div>

      </div>

    </div>
  );
};

export default Login;